<button
  pButton
  style="padding: 0px 2px"
  severity="help"
  size="small"
  (click)="switchTranslation()"
  [label]="visibleText"
  [text]="true"
  [rounded]="true"></button>
